import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
	selector: 'app-pix-qr-code-dynamic-modal-value',
	templateUrl: './modal-value.component.html',
	styleUrls: ['./modal-value.component.styl'],
})
export class PixQrCodeDynamicModalValueComponent {

	public value = 0;
	public form: FormGroup;
	public submited = false;

	constructor(
		public dialogRef: MatDialogRef<PixQrCodeDynamicModalValueComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private formBuilder: FormBuilder,
	) {
		this.value = data.value;
		this.buildForm();
	}

	buildForm() {
		this.form = this.formBuilder.group({
			value: [this.value, [Validators.required, Validators.min(0.01), Validators.max(this.value)]],
		});
	}

	onConfirm = () => {
		this.submited = true;
		if (this.form.valid) {
			this.dialogRef.close(this.form.get('value').value);
		}
	}

	verifyZero() {
		if ($('.currency-field').val() === '0,00') {
			$('.currency-field').val('');
		}
	}

	onClose = () => this.dialogRef.close(false);
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/copy-and-paste/qr-code-dynamic/resume-final/modal-value/modal-value.component.ts